import { computed } from 'vue'
import { useBreakpoints } from '@vueuse/core'
import { useIsMobileAgent } from '@/helpers/detectBrowser'

export function useIsMobile(breakpoint = 640) {
    // eslint-disable-next-line no-restricted-syntax
    const isMobileBreakpoint = useBreakpoints({ breakpoint }).smaller(
        'breakpoint'
    )

    const { isMobileAgent } = useIsMobileAgent()

    const isMobile = computed(() => isMobileBreakpoint.value || isMobileAgent)

    return { isMobile }
}
